import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { KeysOfType } from 'src/app/helpers/utility-functions';
import { ImmoTaskAtelierCheckboxes } from 'src/app/model/immo-task/immo-task-atelier-checkboxes';
import { AuthService } from 'src/app/services/auth.service';
import { SnackService } from 'src/app/services/snack.service';
import { AtelierControllerService } from '../../../service/atelier-controller.service';
import { AtelierTourItemHelper } from '../../atelier-tour-item-helper';
import { AtelierDetailTourItem } from '../../model/atelier-detail-tour-item';
import { AtelierUpdateCheckedIdentifier } from '../../model/atelier-update-checked-identifier';
import { AtelierUpdateCheckedResponse } from '../../model/atelier-update-checked-response';

type CheckboxProp = KeysOfType<ImmoTaskAtelierCheckboxes, boolean>;

@Component({
  selector: 'atelier-task-item-detail',
  templateUrl: './atelier-task-item-detail.component.html',
  styleUrls: ['./atelier-task-item-detail.component.scss']
})
export class AtelierTaskItemDetailComponent implements OnInit {
  @Input()
  item: AtelierDetailTourItem;
  @Input()
  reviewingUserId: number;
  @Input()
  atelierUserId: number;

  @Output()
  checkUpdate = new EventEmitter<AtelierUpdateCheckedResponse>();

  reviewDisabled: boolean = true;
  finishDisabled: boolean = true;

  constructor(
    private atelierService: AtelierControllerService,
    private snackService: SnackService,
    private atelierTourItemHelper: AtelierTourItemHelper,
    private authService: AuthService,
    private _lightbox: Lightbox
  ) {}

  ngOnInit(): void {
    this.reviewDisabled =
      this.authService.getAuthenticatedUser().id !== this.reviewingUserId;
    this.finishDisabled =
      this.authService.getAuthenticatedUser().id !== this.atelierUserId;
  }

  markDescriptionRead(value: boolean): void {
    this.markCheckbox(
      value,
      AtelierUpdateCheckedIdentifier.TASK_DESCRIPTION_READ,
      'descriptionRead'
    );
  }

  markPrepared(value: boolean): void {
    this.markCheckbox(
      value,
      AtelierUpdateCheckedIdentifier.TASK_PREPARED,
      'prepared'
    );
  }

  markReviewed(value: boolean): void {
    this.markCheckbox(
      value,
      AtelierUpdateCheckedIdentifier.TASK_REVIEWED,
      'reviewed'
    );
  }

  private markCheckbox(
    value: boolean,
    identifier: AtelierUpdateCheckedIdentifier,
    prop: CheckboxProp
  ): void {
    this.item.immoTask.atelierCheckboxes[prop] = value;

    this.atelierService
      .updateChecked(this.item.id, identifier, value)
      .then(res => {
        this.item.finished = this.atelierTourItemHelper.immoTaskIsFinished(
          this.item.immoTask
        );
        this.checkUpdate.emit(res);
      })
      .catch(() => {
        this.item.immoTask.atelierCheckboxes[prop] = !value;
        this.snackService.showError(
          'Taak voltooiing kon niet opgeslagen worden.'
        );
      });
  }

  openLightbox(): void {
    if (!CollectionHelper.isPopulated(this.item.immoTask.designPictures)) {
      return;
    }
    const album = this.item.immoTask.designPictures.map(p => {
      return {
        src: `/api/assets/${p.uuid}`,
        caption: p.name,
        thumb: `/api/assets/${p.uuid}`
      };
    });
    this._lightbox.open(album, 0);
  }
}
